import React from 'react';
import { CmsEntities } from 'client/data/models/cms';
import { Link } from 'site-modules/shared/components/link/link';

export function TopRatedItem({ content }) {
  return (
    <Link to={content.metadata('link-url').value()} className="trm-item">
      <div className="title fw-bold size-16 cool-grey-10 d-flex align-items-center mb-0_25">
        {content.metadata('title').value()}
      </div>
      <figure style={{ aspectRatio: '3/2' }} className="img overflow-hidden mb-1">
        <img alt="" loading="lazy" className="w-100" src={content.metadata('media-image').value()} />
      </figure>
      <div>{content.metadata('description').value()}</div>
    </Link>
  );
}

TopRatedItem.propTypes = {
  content: CmsEntities.Content.isRequired,
};
